import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lib-attendance-settings-current-state',
  template: `
    <div class="border border-gray-200 rounded-lg p-4">
      <div class="text-sm font-medium text-gray-700">Current State</div>
      <dl class="mt-3 grid grid-cols-1 gap-3 text-sm text-gray-700">
        <div class="flex justify-between gap-3">
          <dt class="font-medium text-gray-700">Persistence</dt>
          <dd class="text-gray-900">
            {{ hasPersistedSettings() ? 'Saved' : 'Default' }}
          </dd>
        </div>
        <div class="flex justify-between gap-3">
          <dt class="font-medium text-gray-700">Version</dt>
          <dd class="text-gray-900">{{ version() }}</dd>
        </div>
        <div class="flex justify-between gap-3">
          <dt class="font-medium text-gray-700">Last Updated</dt>
          <dd class="text-gray-900">
            {{ (updatedAt() | date : 'medium') || 'Not saved' }}
          </dd>
        </div>
      </dl>
    </div>
  `,
})
export class AttendanceSettingsCurrentStateComponent {
  readonly hasPersistedSettings = input.required<boolean>();
  readonly version = input.required<number>();
  readonly updatedAt = input<string | null | undefined>();
}
